import { render, staticRenderFns } from "./ConsultaSaipComponent.vue?vue&type=template&id=73e269a4"
import script from "./ConsultaSaipComponent.vue?vue&type=script&lang=js"
export * from "./ConsultaSaipComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsultaSaipComponent.vue?vue&type=style&index=0&id=73e269a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports